import Vue from 'vue';

Vue.directive("track-plan", {
	inserted: function(el, binding) {
		let provider = binding.value;
		
		el.onclick = function() {
			let event = "View_" + el.id;
			analytics.track(event, {});

			switch (el.id) {
				case 'adt':
					gtag('event', 'conversion', {'send_to': 'AW-1072619180/G3XGCMughHsQrL27_wM'});
					break;
				case 'frontpoint':
	            	gtag('event', 'conversion', {'send_to': 'AW-1072619180/BQgzCOqhhHsQrL27_wM'});
	            	break;
	          	case 'protect-america':
		            gtag('event', 'conversion', {'send_to': 'AW-1072619180/sizECPyhhHsQrL27_wM'});
		            break;
	          	case 'vivint':
		            gtag('event', 'conversion', {'send_to': 'AW-1072619180/TdAQCPCCh3sQrL27_wM'});
		            break;
			}
		}

		
	}
})


// WEBPACK FOOTER //
// ./src/directives/track-plan.js